export const DEFAULT_SEARCH_SETTINGS = {
  defaultOccupants: {
    adults: 2,
    children: 0,
    childrenAge: [],
    childrenBirthDate: [],
    infants: 0,
  },
  mapView: {
    pinLimit: 20,
    additionalPins: 10,
  },
}
